import AgencyAuthModel from '@/models/AgencyAuthModel'
import AdvertiserAuthModel from '@/models/AdvertiserAuthModel'
import InsertionOrderAuthModel from '@/models/InsertionOrderAuthModel'
import cloneDeep from 'lodash/cloneDeep'

// TODO 移動
class ModelTreeBuilder {
  static build(rawAuthChain, userType) {
    /**
     * AgencyAuthModelがroot
     * AdvertiserAuthModelがその下
     * その下にさらにInsertionOrderAuthModelがぶら下がっている
     * という木構造を作成する
     */
    // 代理店の権限がinheritのとき
    if (rawAuthChain.permission === 'inherit') {
      let permission
      if (rawAuthChain.belong) {
        // 所属している広告主だった場合、accountTypeをみてpermissionを変える
        permission = ModelTreeBuilder.getPermissionFromUserType(userType)
      } else {
        // 所属している広告主出ない場合、権限を持っていないのでnone権限にする
        permission = 'none'
      }
      rawAuthChain.permission = permission
    }
    // rootの作成
    const agencyAuthModel = new AgencyAuthModel(rawAuthChain)

    if (rawAuthChain.advertisers !== undefined) {
      rawAuthChain.advertisers.forEach((advAuth, index, advAuths) => {
        // AdvAuthモデルを作成
        const advertiserAuthModel = new AdvertiserAuthModel(advAuth)
        advertiserAuthModel.setAgencyAuthModel(agencyAuthModel)

        // insertionOrderをもたない場合は処理をしない
        if (advAuth.insertionOrders !== undefined) {
          advAuth.insertionOrders.forEach((ioAuth, index, ioAuths) => {
            // IoAuthモデルを作成
            const insertionOrderAuthModel = new InsertionOrderAuthModel(ioAuth)
            insertionOrderAuthModel.setAdvertiserAuthModel(advertiserAuthModel)

            // advertiserAuthModelの下にinsertionOrderAuthModelをぶら下げる
            advertiserAuthModel.addInertionOrderAuth(insertionOrderAuthModel)
          })
        }
        // agencyAuthModel(root)の下にadvetiserAuthModelをぶら下げる
        agencyAuthModel.addAdvertiserAuths(advertiserAuthModel)
      })
    }
    return agencyAuthModel
  }
  // userTypeからpermissionを取得する
  static getPermissionFromUserType(userType) {
    switch (userType) {
      case 'sales':
        return 'view'
      case 'sales manager':
        return 'readonly'
      case 'operator':
        return 'view'
      case 'operator manager':
        return 'operator'
      case 'administrator':
        return 'admin'
    }
  }
}

const mutations = {
  INITIALIZE(state, { rawAuthChain, userType }) {
    if (rawAuthChain.permission === 'inherit') {
      state.isInheritAgency = true
    }
    state.currentAuthChain = ModelTreeBuilder.build(rawAuthChain, userType)
    state.previousAuthChain = cloneDeep(state.currentAuthChain)
  },
  // 代理店が初めinheritだったときに立てる
  SET_AGENCY_INHERIT(state, { isInherit }) {
    state.isInheritAgency = isInherit
  },
  // 現在編集中のuserTypeを保持
  SET_CURRENT_EDITING_USER_TYPE(state, { userType }) {
    state.currentEditingUserType = userType
  },
  SET_PARENT_PERMISSION(state, { permission }) {
    state.currentAuthChain.setPermission(permission)
  },
  // insertionOrderのpermissionをかえる
  SET_CHILD_PERMISSION(state, { id, permission }) {
    const advertiserAuth = state.currentAuthChain.advertiserAuths.find(adv => {
      return adv.id === id
    })
    advertiserAuth.setPermission(permission)
  },
  // insertionOrderのpermissionをかえる
  SET_GRONDCHILD_PERMISSION(state, { id, parentId, permission }) {
    const advertiserAuth = state.currentAuthChain.advertiserAuths.find(adv => {
      return adv.id === parentId
    })
    const ioAuth = advertiserAuth.insertionOrderAuths.find(io => {
      return io.id === id
    })
    ioAuth.setPermission(permission)
  },
  // リセット時、previousの値をcurrentに入れる
  RESET(state) {
    state.currentAuthChain = cloneDeep(state.previousAuthChain)
  },
  // すべての子供についてinheritにする
  SET_ALL_INHERIT(state, { advId }) {
    const advertiserAuth = state.currentAuthChain.advertiserAuths.find(adv => {
      return adv.id === advId
    })
    advertiserAuth.insertionOrderAuths.forEach((io, index, ios) => {
      io.setPermission('inherit')
    })
  },
}

export default mutations
